<app-cargando *ngIf="cargando"></app-cargando>

<div class="modal-header card-header">
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="cerrar()">×</button>
</div>

<div class="card">
  <div class="card-header">
    <h3>Oportunidad</h3>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="form-group col-sm-12" *ngIf="crearDesdeSegumiento">
        <label class="control-label" for="Nombre">Nombre oportunidad</label>
        <input
        [(ngModel)]="body.Name"
          class="form-control text-box single-line"
          name="Nombre"
          type="text"
          value=""
        />
        <span
          class="field-validation-valid text-danger"
          data-valmsg-for="Nombre"
          data-valmsg-replace="true"
        ></span>
      </div>

      <div class="form-group col-sm-6" *ngIf="!crearDesdeSegumiento">
        <label class="control-label" for="Nombre">Nombre oportunidad</label>
        <input
        [(ngModel)]="body.Name"
          class="form-control text-box single-line"
          name="Nombre"
          type="text"
          value=""
        />
        <span
          class="field-validation-valid text-danger"
          data-valmsg-for="Nombre"
          data-valmsg-replace="true"
        ></span>
      </div>

      <div class="form-group col-sm-6" *ngIf="!crearDesdeSegumiento">
        <label class="control-label" for="Empresa">Empresa</label>
        <br />
        <input
          class="form-control select2-hidden-accessible"
          style="width: 100%"
          [(ngModel)]="body.CardName"
          (click)="selecionarCliente()"
          >
        <a href="/BusinessPartner/Venta" style="color: #91CA41;">Nueva empresa</a>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label" for="Fechacreacion">Fecha Creación</label>

        <input
          class="form-control text-box single-line"
          type="date"
          [(ngModel)]="body.CreateDate"
        />
        <span class="field-validation-valid text-danger"></span>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label" for="Fecharequeridacliente">
          Fecha de Cierre
        </label>

        <input
          class="form-control text-box single-line"
          type="date"
          [(ngModel)]="body.PredDate"

        />
        <span class="field-validation-valid text-danger"></span>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label" for="Etapa">Etapa</label>
        <select class="Contactos form-control select2-hidden-accessible" style="width: 100%" [(ngModel)]="body.OPR1[0].Step_Id">
          <option *ngFor="let item of Etapas" value="{{item.StepId}}">
            {{item.Descript}}
          </option>
        </select>
      </div>


      <div class="form-group col-sm-6">
        <label class="control-label" for="Montoestimadooportunidad"
          >Monto estimado oportunidad</label
        >
        <input
          class="form-control text-box single-line"
          type="number"
          [(ngModel)]="body.OPR1[0].MaxSumLoc"
        />
        <span class="field-validation-valid text-danger"></span>
      </div>

      <div class="form-group col-sm-12">
        <label class="control-label" for="Montoestimadooportunidad"
          >Vendedor</label
        >
        <select class="Contactos form-control select2-hidden-accessible" style="width: 100%" [(ngModel)]="body.SlpCode">
          <option *ngFor="let item of listaVendedor" value="{{item.SlpCode}}">
            {{item.SlpName}}
          </option>
        </select>
      </div>

    </div>

    <div class="form-group">
      <button class="btn btn-primary" style="width: 100%;background: #91CA41;color: #444D55;" (click)="guardar()">
        Guardar
      </button>
    </div>

  </div>
</div>
